<template>
  <div class="school-orders">
    <v-row>
      <v-col cols="12" md="3">
        <SchoolNavigation />
      </v-col>
      <v-col cols="12" md="9">
        <v-sheet color="white" class="pa-5" rounded>
          <h3>لیست سفارشات</h3>
          <v-data-table
            v-if="batches"
            :headers="headers"
            :items="batches"
            :items-per-page="5"
            class="elevation-1 mt-5"
          >
            <template v-slot:[`item._id`]="{ item }">
              <v-btn
                depressed
                small
                router
                :to="{ name: 'DiscountReport', params: { id: item._id } }"
              >
                <v-icon small class="ml-1">mdi-chart-box-outline</v-icon>
                مشاهده گزارشات
              </v-btn>
              <v-btn
                depressed
                small
                class="mx-2"
                :loading="loading"
                :disable="loading"
                @click="handlePrintCodes(item._id)"
              >
                <v-icon small class="ml-1">mdi-printer</v-icon>
                چاپ کد تخفیف
              </v-btn>
              <v-btn
                depressed
                small
                router
                :to="{ name: 'OrderVerify', params: { id: item.order } }"
              >
                <v-icon small class="ml-1">mdi-chart-box-outline</v-icon>
                مشاهده فاکتور
              </v-btn>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import SchoolNavigation from "./SchoolNavigation.vue";
export default {
  name: "school-orders-component",
  components: {
    SchoolNavigation
  },
  data: () => {
    return {
      loading: false,
      headers: [
        { text: "نام سری", align: "center", value: "title" },
        { text: "تعداد کد", align: "center", value: "count" },
        { text: "تاریخ تولید", align: "center", value: "createDate" },
        { text: "اقدامات", align: "center", value: "_id" }
      ],
      batches: null
    };
  },
  created() {
    this.handleGetDiscountBatch();
  },
  methods: {
    handleGetDiscountBatch() {
      this.$api.get("/discountCodeBatchs").then((res) => {
        this.batches = res.data.discountCodeBatchs;
      });
    },
    handlePrintCodes(id) {
      this.loading = true;
      this.$api
        .get("/discountCodes/" + id)
        .then((res) => {
          const discountCodes = res.data.discountCodes;
          const doc = this.$jspdf({
            orientation: "portrait",
            format: "a4"
          });
          doc.setFont("iransansdn");
          var index = 1;
          var pageNumber = 1;
          var codeHeight = 118.8;
          var dateHeight = 106.5;
          var bookHeight = 122;
          var bg =
            "https://pirls.ir" +
            require("@/assets/images/discountCode/bg.jpg");
          var logo =
            "https://api.pirls.ir/" +
            "user/image/" +
            this.$store.getters.user._id;

          console.log(logo);

          discountCodes.forEach((element) => {
            if (index == 1) {
              doc.addImage(bg, 0, 0, 210, 297);
              if (logo) {
                doc.addImage(logo, 5, 5);
              }
            }

            if (element.used) {
              doc.setTextColor("#666666");
              doc.setFontSize("16");
              doc.text(
                "استفاده شده توسط : " +
                  element.user.firstname +
                  " " +
                  element.user.lastname,
                105,
                codeHeight - 1.5,
                {
                  align: "center"
                }
              );
              doc.setTextColor("#999999");
              doc.setFontSize("8");
              doc.text(
                "کتاب : " + element.book.title + " - " + element.book.grade,
                105,
                bookHeight,
                {
                  align: "center"
                }
              );
              const date = this.$moment(element.useDate, "YYYY/MM/DD")
                .locale("fa")
                .format("YYYY/MM/DD");
              doc.setTextColor("#666666");
              doc.setFontSize("7.5");
              doc.text("تاریخ استفاده : " + date, 25, dateHeight);
            } else {
              doc.setTextColor("#444444");
              doc.setFontSize("18");
              doc.text(element.code, 105, codeHeight, {
                align: "center"
              });
            }

            index = index + 1;
            if (index != 1) {
              codeHeight = codeHeight + 25.5;
              dateHeight = dateHeight + 25.5;
              bookHeight = bookHeight + 25.5;
            }
            if (index > 5) {
              doc.setTextColor("#999999");
              doc.setFontSize("9");
              doc.text("صفحه " + pageNumber.toString(), 105, 32, {
                align: "center"
              });

              pageNumber = pageNumber + 1;
              doc.addPage();

              index = 1;
              codeHeight = 118;
              dateHeight = 110;
              bookHeight = 125;
            }
          });

          var pageCount = doc.internal.getNumberOfPages();

          doc.deletePage(pageCount);

          doc.save("discounts.pdf");

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
